<button
  [type]="type"
  [class]="'btn ' + variant"
  [class.full-width]="fullWidth"
  [disabled]="disabled"
  [title]="ariaLabel || ''"
  [attr.aria-label]="ariaLabel || null"
  (click)="handleClick($event)"
>
  <span class="btn-content">
    <ng-content></ng-content>
  </span>
</button>
